import { useEffect, useState } from "react";
import { API_URLS } from "../../apiUrl";
import axiosInstance from "../../components/axiosInstance";

function StreetDropdown(muniCipalityId: any, ward_ids: any) {
  const [streetList, setStreetList] = useState<any>([]);
  const [loadingStreetList, setLoadingStreetList] = useState(false);
  const [isDropdownOpenStreet, setIsDropdownOpenStreet] = useState(false);

  const fetchStreet = async () => {
    if (loadingStreetList) return;
    setLoadingStreetList(true);

    try {
      const { data } = await axiosInstance.post(
        API_URLS.streetWordWise,
        {
          municipalityTbl_id: muniCipalityId,
          ward_primary_id: ward_ids,
          page: 1,
          limit: 100000,
          surveyer_id: 0,
        }
      );

      const streets = data?.data?.data || [];
      setStreetList(streets);
    } catch (error) {
      console.error("Error fetching Borough", error);
    } finally {
      setLoadingStreetList(false);
    }
  };

  useEffect(() => {
    if (muniCipalityId && ward_ids) {
      setStreetList([]);
      fetchStreet();
    }
  }, [muniCipalityId, ward_ids]);

  return [
    setIsDropdownOpenStreet,
    isDropdownOpenStreet,
    fetchStreet,
    streetList,
    loadingStreetList,
    setLoadingStreetList,
  ];
}

export default StreetDropdown;